export default "__VITE_ASSET__C9ObSm8B__"